import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent implements OnInit,OnChanges {

  @Input() label = ''
  @Input() showLabel : boolean = false
  @Input() optionList = [];
  @Input() selectedId = '0';
  @Output() onItemChange = new EventEmitter();
  selectedItem: any;
  currentWidth: number = window.innerWidth;
  
  constructor(){}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const newWidth = (event.target as Window).innerWidth;
    if (newWidth <= 576) {
      this.showLabel = false;
    } else {
      this.showLabel = true
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(()=>{
      this.selectedItem = this.optionList.find((item) => item.id === this.selectedId);
    },2500)
  }

  ngOnInit(): void {
    if(!this.label){
      this.selectedItem = this.optionList.find((item) => item.id === this.selectedId);
    }
  }

  onChange(selectedValue){
    let item = this.optionList.find((item) => item.id === selectedValue);
    this.selectedItem = this.label ? '' : item;
    this.onItemChange.emit(item);
  }

}
